import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../components/ui/card';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Badge } from '../components/ui/badge';
import { Boxes, Settings } from 'lucide-react';
import { WizardStep } from '../components/FeatureWizard';

export const getProductsWizardSteps = (
  translate: (key: string) => string
): WizardStep[] => {
  return [
    {
      id: 'welcome',
      title: translate('pos.wizards.products.welcome.title'),
      description: translate('pos.wizards.products.welcome.description'),
      content: (
        <div>
          <Alert className="mb-4">
            <AlertDescription>
              {translate('pos.wizards.products.welcome.info')}
            </AlertDescription>
          </Alert>
          <p className="text-sm text-muted-foreground">
            {translate('pos.wizards.products.welcome.content')}
          </p>
        </div>
      ),
    },
    {
      id: 'manageProducts',
      title: translate('pos.wizards.products.manage.title'),
      description: translate('pos.wizards.products.manage.description'),
      content: (
        <div>
          <Card className="mb-4 border-primary/20 bg-primary/5">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-primary text-sm">
                <Boxes className="h-4 w-4" />
                {translate('pos.wizards.products.manage.highlight')}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm">
                {translate('pos.wizards.products.manage.details')}
              </p>
            </CardContent>
          </Card>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <Badge variant="outline" className="mt-0.5 flex-shrink-0">
                {translate('pos.products.name')}
              </Badge>
              <p className="text-xs text-muted-foreground">
                {translate('pos.wizards.products.manage.step1')}
              </p>
            </div>
            <div className="flex items-start gap-3">
              <Badge variant="outline" className="mt-0.5 flex-shrink-0">
                {translate('pos.navigation_groups.products')}
              </Badge>
              <p className="text-xs text-muted-foreground">
                {translate('pos.wizards.products.manage.step2')}
              </p>
            </div>
          </div>
        </div>
      ),
      action: {
        label: translate('pos.wizards.products.manage.action'),
        onClick: () => {
          window.location.href = '/products';
        },
      },
    },
    {
      id: 'productSettings',
      title: translate('pos.wizards.products.settings.title'),
      description: translate('pos.wizards.products.settings.description'),
      content: (
        <div>
          <Card className="mb-4 bg-secondary/10 border-secondary/20">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center gap-2 text-secondary text-sm">
                <Settings className="h-4 w-4" />
                {translate('pos.wizards.products.settings.highlight')}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm">
                {translate('pos.wizards.products.settings.details')}
              </p>
            </CardContent>
          </Card>
          <p className="text-sm text-muted-foreground">
            {translate('pos.wizards.products.settings.tip')}
          </p>
        </div>
      ),
    },
  ];
};
